export default __webpack_public_path__ + "static/media/static_img_commonocean_logo_black.1583472c.svg";